import {
  Box,
  Button,
  Icon,
  Pagination,
  Table,
  TableHeader,
  Text,
} from '@fairfashion/design-system'
import { useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { IReportsResponse } from '../../../sdk/reports/reports.types'
import {
  getCustomHeader,
  isValidHeader,
  removeSubstring,
  textInfo,
  translateKey,
} from '../reports.utils'

interface CustomTableProps {
  data: IReportsResponse[]
  totalPages: number
  setPage: (value: number) => void
  link?: string | null
  page: number
}
export const CustomTable = ({
  data,
  totalPages,
  page,
  setPage,
  link,
}: CustomTableProps) => {
  const pathname = removeSubstring(useLocation().pathname, '/reports/')

  const theme = useTheme()

  const headers = (() => {
    const result: TableHeader[] = []
    if (data) {
      const keys = Object.keys(data[0])

      for (const key of keys) {
        if (isValidHeader(key)) {
          const customHeader = getCustomHeader(key)
          if (customHeader) {
            result.push(customHeader)
          } else {
            const transformedObj = {} as TableHeader
            transformedObj['key'] = key
            transformedObj['label'] = translateKey(key)
            result.push({ ...transformedObj, minWidth: '150px' })
          }
        }
      }
    }

    return result
  })()

  return (
    <Box direction="column" width="100%" gap={4}>
      <Box
        flex={1}
        direction="column"
        width="100%"
        backgroundColor="white"
        borderRadius={theme.border_radius.box}
        border={{
          color: 'grey_5',
          width: 1,
        }}
        boxShadow={theme.box_shadow.card}
      >
        <Box
          width="100%"
          padding={3}
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <Box direction="column" flex={1}>
            <Text fontWeight={500}>{textInfo(pathname)?.title}</Text>
            <Text color="grey_3">{textInfo(pathname)?.subtitle}</Text>
          </Box>
          <Box min-width="50%" justifyContent="flex-end">
            <a href={`${link}`} target="_blank">
              <Button>
                <Icon name="upload2" color="white" />
                Exportar relatório
              </Button>
            </a>
          </Box>
        </Box>
        <Table
          headers={headers}
          data={data}
          borderRadius={`0 0 ${theme.border_radius.box} ${theme.border_radius.box}`}
          footer={
            <Box justifyContent="center" width="100%" paddingY={1}>
              <Pagination
                total={totalPages}
                current={page >= 1 ? page : 1}
                onChange={(_page) => setPage(_page)}
              />
            </Box>
          }
        />
      </Box>
    </Box>
  )
}
